"use strict";
var Collections = require("../collections/collections");
var providers = require("./providers/providers");
var Settings = (function () {
    function Settings() {
        this.Providers = providers;
        this._settings = new Collections.Dictionary();
    }
    Settings.prototype.add = function (key, value) {
        this._settings.add(key, value);
    };
    Settings.prototype.addJSON = function (key, value) {
        this._settings.add(key, JSON.stringify(value));
    };
    Settings.prototype.apply = function (hash) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                _this._settings.merge(hash);
                resolve();
            }
            catch (e) {
                reject(e);
            }
        });
    };
    Settings.prototype.load = function (provider) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            provider.getConfiguration().then(function (value) {
                _this._settings.merge(value);
                resolve();
            }).catch(function (reason) {
                reject(reason);
            });
        });
    };
    Settings.prototype.get = function (key) {
        return this._settings.get(key);
    };
    Settings.prototype.getJSON = function (key) {
        var o = this.get(key);
        if (typeof o === "undefined" || o === null) {
            return o;
        }
        return JSON.parse(o);
    };
    return Settings;
}());
exports.Settings = Settings;
